import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import Form from "forms/Form";
import MainContext from "context/MainContext";
import { SPEAKERS } from "api/config/endpoints";
import { SPEAKER } from "api/config/models";
// import "./SpeakerForm/SpeakerForm.scss"
import { getLanguages, getSpeaker } from "api/functions/functions";
import Button from "ui/Button";
import useMediaGallery from "hooks/useMediaGallery";
import formWrapper from "hoc/formWrapper";
import LanguageSelector from "components/LanguageSelector/LanguageSelector";
import { InlineLoading } from "carbon-components-react";


const SpeakerForm = (props) => {
    const context = useContext(MainContext)
    const [loaded, setLoaded] = useState(false);
    const [languages, setLanguages] = useState([])
    // const [selectedLang, setSelectedLang] = useState("en")
    const [selectedLangCode, setSelectedLangCode] = useState("en")
    const [defaultValues, setDefaultValues] = useState({});
    const [itemId, setItemId] = useState(null);
    const endpoint = `${SPEAKERS}`;
    const {
        openMediaGallery,
        setAttachTo,
        setAttached,
        isMediaGalleryOpen
    } = useMediaGallery()

    useEffect(() => {
        async function fetchData() {
            const langs = await getLanguages()
            setLanguages(langs)
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (_.isEmpty(languages)) {
            return false
        }
        // setSelectedLang("en")
        setSelectedLangCode("en")
    }, [languages])

    useEffect(() => {
        let data = { ...props.data }
        if (data !== defaultValues) {
            // if (!_.isEmpty(props.data)) {
            //     setItemId(props.data.id)
            // }
            setItemId(_.get(props, "data.id"))
            setDefaultValues(data)
            if (data.media_id) {
                setAttached([
                    data.media_id
                ])
            }
            setLoaded(true)
        }
    }, [props.data]);

    const loadData = async (skipAttached) => {
        const data = await getSpeaker(itemId)
        try {
            console.log("res.data", data)
            if (!_.isEmpty(data.data)) {
                setDefaultValues(data.data);
                setLoaded(true);
            }
        }
        catch (e) { }
    }

    useEffect(() => {
        if (isMediaGalleryOpen()) {
            loadData(true)
        }
    }, [context.mediaGalleryAttached])


    const getValue = (name, type) => {
        let value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;

        if (["description", "role"].includes(name)) { //"title", 
            value = _.get(value, selectedLangCode)
        }
        switch (type) {
            case "bool":
                return value !== 0;
            default:
                return value;
        }
    };

    const onSubmit = (data) => {

        if (!_.isEmpty(data) && data !== defaultValues) {
            setDefaultValues(data)
            try {
                setItemId(data.id)
            }
            catch (e) {
                console.error("EEEEEEEEE")
            }
        }
        // const toast = (
        //     <Toast
        //         key={moment().format("X")}
        //         kind="success"
        //         title="Changes saved"
        //     />
        // )
        // context.addToast(toast)
        if (props.onItemChanged) {
            props.onItemChanged(data)
        }
    }

    const onlanguagechange = (e) => {
        try {
            const langCode = e.target.value
            // setSelectedLang(e.target.value)
            setSelectedLangCode(langCode)
        }
        catch (e) { }
    }

    const onLanguagesLoaded = (e) => {
        try {
            let defaultLanguage = null
            if (context.evt?.default_language) {
                defaultLanguage = context.evt.default_language
            }
            else {
                defaultLanguage = "en"
            }
            setSelectedLangCode(defaultLanguage)
        }
        catch (e) { }
    }

    let fields = 1
        ? [
            {
                elementType: "input",
                id: "firstname",
                name: "firstname",
                labelText: "Firstame",
                value: getValue("firstname"),
            },
            {
                elementType: "input",
                id: "lastname",
                name: "lastname",
                labelText: "Lastame",
                value: getValue("lastname"),
            },
            {
                elementType: "wysiwyg",
                id: "role",
                name: "role",
                labelText: "Title",
                value: getValue("role"),
            },
            {
                elementType: "wysiwyg",
                id: "description",
                name: "description",
                labelText: "Bio",
                value: getValue("description"),
            },
        ]
        : [];

    // if (options && loaded) {
    //     fields.push({
    //         elementType: "editable-list",
    //         id: "options_draft",
    //         name: "options_draft",
    //         invalidText: "Invalid error message.",
    //         labelText: "Question",
    //         placeholder: "Insert question body",
    //         value: getValue("options_draft")
    //     })
    // }
    const setMediaGallery = () => {
        setAttachTo({
            model: SPEAKER,
            params: {
                id: itemId
            }
        })
        // context.setAfterAttachChange(loadData)
        // setOnAttachChange(loadData)
        openMediaGallery()
    }

    const image = (getValue("media_id") && !_.isEmpty(getValue("media"))) ? (
        <div onClick={setMediaGallery}>
            <img src={getValue("media").url}
                alt=""
                style={{
                    display: "block",
                    marginBottom: "2rem",
                    maxWidth: "300px"
                }}
            />
        </div>
    ) : (
        <Button onClick={setMediaGallery}>Attach profile picture</Button>
    )

    return (
        <>
            {
                languages ? (
                    <>
                        <LanguageSelector
                            // languages={languages}
                            selectedLangCode={selectedLangCode}
                            onChange={(e) => onlanguagechange(e)}
                            onLanguagesLoaded={(e) => onLanguagesLoaded(e)}
                        />

                        <div className={props.className} key={`form-speaker-${itemId}-${selectedLangCode}`}>
                            {itemId ? image : null}
                            <Form
                                blockTouched={true}
                                itemId={itemId}
                                fields={fields}
                                endpoint={endpoint}
                                loaded={loaded}
                                setAutoId={true}
                                // saveOnChange={true}
                                // hideSubmitButton={true}
                                hasStandardFooter={true}
                                defaultParams={{
                                    lang_id: selectedLangCode
                                }}
                                onSubmit={(data) => onSubmit(data)}
                                abortButton={true}
                                onAbortClicked={props.onAbortClicked}
                                key={"speaker-form-" + itemId}
                            />
                        </div>
                    </>
                ) : (
                    <InlineLoading />
                )
            }
        </>
    );
};

export default SpeakerForm;

export const WrappedSpeakerForm = formWrapper(SpeakerForm)
